export default __webpack_public_path__ + "static/media/addimage.a458a71c.svg";